<style scoped>

</style>

<template>
    <div>
      <div>
        <h1>物品配置</h1>
      </div>
      <div>
          <el-upload
              class="upload-demo"
              ref="upload"
              :action="action"
              :limit=1
              accept=".xls,.xlsx"
              style="width:360px"
              :file-list="fileList"
              :on-change="changeFile"
              :on-remove="removeFile"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
              <div slot="tip" class="el-upload__tip">只能上传单个xls/xlsx文件</div>
          </el-upload>
      </div>
    <el-button v-if="serverFileName != '' && serverFileName != null" size="small" type="primary" icon="el-icon-download" @click="downloadFile(serverFileName)">服务端配置下载</el-button>
    <el-button v-if="clientFileName != '' && clientFileName != null" size="small" type="primary" icon="el-icon-download" @click="downloadFile(clientFileName)">客户端配置下载</el-button>
    </div>
</template>

<script>
import app from '@/App.vue';
import {commitNewConfig, downloadFile} from '@/request/api';
export default {
    name: 'User',
    data() {
      return {
        fileList: [],
        action: "/baseConfig/commitNewConfig",
        serverFileName: "",
        clientFileName: ""
      };
    },
    methods: {
      changeFile(file, fileList) {
        this.fileList = fileList;
      },
      removeFile(file, fileList) {
        this.fileList = fileList;
      },
      submitUpload() {
        var that = this;
        var uploadFile = this.fileList[0].raw;
        let formdata = new FormData();
        formdata.append("file", uploadFile)
        console.log(formdata)
        commitNewConfig(formdata).then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("上传成功");
                var data = res.data;
                that.serverFileName = data.serverFileName;
                that.clientFileName = data.clientFileName;
            }
        })
      },
      downloadFile(fileName) {
        downloadFile({
          'fileName': fileName
        }).then(res => {
          if (res != null) {
            const blob = new Blob([JSON.stringify(res, null, '\t')])
            // const blob = new Blob([res])
            console.log(blob)
            this.saveFile(blob, fileName);
          } else {
            this.$message.success("文件下载失败");
          }
            
        })
      },
      saveFile(data, name) {
        try {
          const blobUrl = window.URL.createObjectURL(data)
          console.log(blobUrl)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.download = name
          a.href = blobUrl
          a.click()
          
        } catch (e) {
          this.$message.success("保存文件出错");
        }
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/configs/propsConfig.vue